import { shortenSector } from '../../../utils/abbreviations';
import {normalizeWeights} from "../../../lib/weightSchemes";

export const prepareInclusionExclusionScatter = (includedData, excludedData, count = false) => {
  const includedSectors = includedData.reduce((acc, curr) => {
    const key = curr.sector;
    const value = count ? 1 : curr.wgt;

    acc[key] = (acc[key] || 0) + value;
    return acc;
  }, {});

  const excludedSectors = excludedData.reduce((acc, curr) => {
    const key = curr.sector;
    const value = count ? 1 : curr.wgt;

    acc[key] = (acc[key] || 0) + value;
    return acc;
  }, {});

  const sectors = [
    ...new Set([
      ...Object.keys(includedSectors),
      ...Object.keys(excludedSectors),
    ]),
  ].sort();

  const data = sectors.flatMap((sector) => [
    {
      sector: shortenSector(sector),
      size: includedSectors[sector] || 0,
      cat: shortenSector(sector),
      included: true,
    },
    {
      sector: shortenSector(sector),
      size: excludedSectors[sector] || 0,
      cat: shortenSector(sector),
      included: false,
    },
  ]);

  return data;
};



export const packStockBySector = (kept, removed) => {
  // Create a map to hold the structure by sector
  const sectorMap = {};


  // Process kept stocks
  kept.forEach(stock => {
    const { sector, symbol, wgt } = stock;
    if (!sectorMap[sector]) {
      // Initialize the sector with a children array
      sectorMap[sector] = { name: sector, children: [] };
    }

    // Push the kept stock directly to the sector's children
    sectorMap[sector].children.push({
      name: `${symbol}`,
      value: wgt*100,
      children: []
    });
  });



  // Process removed stocks
  removed.forEach(stock => {
    const { sector, symbol, wgt } = stock;
    if (!sectorMap[sector]) {
      // Initialize the sector if it doesn't exist
      sectorMap[sector] = { name: sector, children: [] };
    }

    // Check if the sector already has a "Removed" node, create if not
    let removedNode = sectorMap[sector].children.find(child => child.name === `${sector} Removed`);
    if (!removedNode) {
      removedNode = { name: `${sector} Removed`, children: [] };
      sectorMap[sector].children.push(removedNode);
    }

    // Add the removed stock to the "Removed" node's children
    removedNode.children.push({
      name: `${symbol}`,
      value: wgt,
      children: [] // Ensure removed stocks have a 'children' field, even if empty
    });
  });

  // Return a JSON object with the portfolio root and sectors as children
  return {
    name: "Portfolio",
    children: Object.values(sectorMap)
  };
};


export const packStocksWithETFs = (etfs, topLimit = 50) => {
  const stockMap = {};

  // Step 1: Aggregate stock weights across all ETFs
  etfs.forEach(etf => {
    etf.holdings.forEach(stock => {
      const { symbol, wgt } = stock;

      // Initialize stock entry if it doesn't exist
      if (!stockMap[symbol]) {
        stockMap[symbol] = { name: symbol, totalWeight: 0, children: [] };
      }

      // Add ETF-specific weight to the stock's total weight
      stockMap[symbol].totalWeight += wgt;

      // Add ETF as a sub-circle under the stock
      stockMap[symbol].children.push({
        name: etf.symbol,
        value: wgt,
      });
    });
  });

  // Step 2: Sort stocks by total weight and limit to top N (e.g., 50)
  const topStocks = Object.values(stockMap)
    .sort((a, b) => b.totalWeight - a.totalWeight)
    .slice(0, topLimit);

  // Step 3: Prepare the final circle structure
  return {
    name: "Portfolio",
    children: topStocks.map(stock => ({
      name: stock.name,
      value: stock.totalWeight,
      children: stock.children,
    })),
  };
};



